import React from "react";

import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Text,
  Title,
} from "@tremor/react";

const orderNumber = (item) =>
  [item.ar_diataxis, item.etos_diataxis]
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join("/");

const DiataxeisProdikasias = ({ data }) => {
  return (
    <Card className="mt-3">
      <Title>Διατάξεις Προδικασίας</Title>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Διάταξη</TableHeaderCell>
            <TableHeaderCell>Ημ/νία</TableHeaderCell>
            <TableHeaderCell>Δικαστής</TableHeaderCell>
            <TableHeaderCell>Αποτέλεσμα</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => (
            <React.Fragment key={`diat-${i}`}>
              <TableRow>
                <TableCell>{orderNumber(item)}</TableCell>
                <TableCell>
                  <Text>{item.imnia_diataxis}</Text>
                </TableCell>
                <TableCell>{item.dikastis}</TableCell>
                <TableCell>{item.apotelesma}</TableCell>
              </TableRow>
              {/* Το κείμενο είναι ολόκληρη παράγραφος: δική του γραμμή σε όλο το πλάτος */}
              {String(item.keimeno ?? "").trim() && (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    style={{ whiteSpace: "normal", lineHeight: 1.6 }}
                  >
                    <strong>Κείμενο:</strong> {item.keimeno}
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default DiataxeisProdikasias;
